import styles from "./StatusBadge.module.css";
const StatusBadge = ({ status }) => {
  3;
  const getStatusClass = () => {
    switch (status.toLowerCase()) {
      case "active":
        return styles.active;
      case "verified":
        return styles.verified;
      case "inactive":
        return styles.inactive;
      case "banned":
        return styles.error;
      case "pending":
        return styles.pending;
      case "not uploaded":
        return styles.warning;
      default:
        return styles.default;
    }
  };

  return (
    <span className={`${styles.badge} ${getStatusClass()}`}>{status}</span>
  );
};

export default StatusBadge;
